import AuthPage from "@/app/(auth)/components/AuthPage";
import { Button } from "@/ui";
import addSeconds from "date-fns/addSeconds";
import Countdown from "@/app/(auth)/components/Countdown";
import React, { useState } from "react";

export default function VerifyEmailForm({ onResend }) {
    const [authTime, setAuthTime] = useState(addSeconds(new Date(), 30));
    const resend = () => {
        setAuthTime(addSeconds(new Date(), 30));
        onResend();
    };

    return (
        <AuthPage strapline="Setting up your account">
            <h2 className="text-xl font-semibold font-poppins">
                Verify your email
            </h2>
            <p className="text-base font-lato mt-1">
                Please check your email inbox for a verification link. Make sure
                to check your spam or junk folder as well.
            </p>

            <div className="mt-10 space-y-4 text-center">
                <p className="font-semibold font-poppins">
                    Didn&apos;t get an email?
                </p>
                <Countdown target={authTime}>
                    {({ remaining }) => {
                        if (remaining <= 0) {
                            return (
                                <Button fill variant="link" onClick={resend}>
                                    Resend code
                                </Button>
                            );
                        } else {
                            return (
                                <span className="flex items-center justify-center rounded-md px-3.5 py-2.5 text-base w-full font-semibold">
                                    Resend code in 00:
                                    {String(remaining).padStart(2, "0")}
                                </span>
                            );
                        }
                    }}
                </Countdown>
            </div>
        </AuthPage>
    );
}
